"use strict";

/*** Smooth Scroll ***/
$('a[href*="#"]') // Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').not('[href="#platform-product"]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]"); // Does a scroll target exist?

    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $("html, body").animate({
        scrollTop: target.offset().top - 75
      }, 1000);
    }
  }
});
/*** IE Custom Object Fit ***/

var userAgent, ieReg, ie;
userAgent = window.navigator.userAgent;
ieReg = /msie|Trident.*rv[ :]*11\./gi;
ie = ieReg.test(userAgent);

if (ie) {
  $(".full-image-container").each(function () {
    var $container = $(this),
        imgUrl = $container.find("img").prop("src");

    if (imgUrl) {
      $container.css("backgroundImage", "url(" + imgUrl + ")").addClass("custom-object-fit");
    }
  });
}
/*** Calendar Reminder ***/


var icsFile = null;

function convertDate(date) {
  var event = new Date(date).toISOString();
  event = event.split("T")[0];
  event = event.split("-");
  event = event.join("");
  return event;
}

function createCalendarFile(today, date, summary, location, description) {
  var calendarEvent = "BEGIN:VCALENDAR\n" + "VERSION:2.0\n" + "PRODID:-//Will Power Reminder//EN\n" + "CALSCALE:GREGORIAN\n" + "METHOD:PUBLISH\n" + "BEGIN:VEVENT\n" + "SUMMARY:" + summary + "\n" + "LOCATION:" + location + "\n" + "UID:" + "will-power-reminder-" + convertDate(today) + "T" + ("0" + today.getHours()).slice(-2) + ("0" + today.getMinutes()).slice(-2) + ("0" + today.getSeconds()).slice(-2) + "\n" + "DTSTART:" + convertDate(date) + "\n" + "DTEND:" + convertDate(date) + "\n" + "DTSTAMP:" + convertDate(today) + "T" + ("0" + today.getHours()).slice(-2) + ("0" + today.getMinutes()).slice(-2) + ("0" + today.getSeconds()).slice(-2) + "\n" + "DESCRIPTION:" + description + "\n" + "END:VEVENT\n" + "END:VCALENDAR";
  var data = new File([calendarEvent], {
    type: "text/plain"
  }); // If we are replacing a previously generated file we need to
  // manually revoke the object URL to avoid memory leaks.

  if (icsFile !== null) {
    window.URL.revokeObjectURL(icsFile);
  }

  icsFile = window.URL.createObjectURL(data);
  return icsFile;
}

if ($(".standalone-reminder-button").length) {
  $(".standalone-reminder-button").click(function (e) {
    // Get date right now
    createStandaloneDate = new Date(); // Get date 1 year from now

    calendarStandaloneDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1)); // Get calendar event title

    calendarStandaloneTitle = "".concat(reminderCalendarStandaloneTitle); // Get calendar location

    calendarStandaloneLocation = "".concat(reminderCalendarStandaloneLocation); // Get calendar event description

    calendarStandaloneDescription = "".concat(reminderCalendarStandaloneDescription); // Create ics file

    $(this).attr("href", createCalendarFile(createStandaloneDate, calendarStandaloneDate, calendarStandaloneTitle, calendarStandaloneLocation, calendarStandaloneDescription));
  });
}

;
document.addEventListener("DOMContentLoaded", function () {
  var headerWillPower = document.getElementById("header-willpower");
  var options = {
    offset: 75
  };
  var headroom = new Headroom(headerWillPower, options);
  headroom.init();
});